import { render, staticRenderFns } from "./StatisticsMetadataDetails.vue?vue&type=template&id=5f24791c&scoped=true"
import script from "./StatisticsMetadataDetails.vue?vue&type=script&lang=js"
export * from "./StatisticsMetadataDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24791c",
  null
  
)

export default component.exports